module.exports = require("@swa-ui/dotcom");